import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export function Field({ label, children, hint }: { label: string; children: React.ReactNode; hint?: string }) {
  return (
    <label className="grid gap-2 text-sm font-semibold text-ink">
      <span>{label}</span>
      {children}
      {hint ? <span className="text-xs font-normal text-ink/70">{hint}</span> : null}
    </label>
  );
}

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        'h-11 w-full rounded-sm border border-ink/20 bg-ivory px-3.5 text-sm text-ink outline-none transition placeholder:text-ink/70 focus:border-black focus:ring-4 focus:ring-black/10',
        className
      )}
      {...props}
    />
  );
}

export function Select({ className, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={cn(
        'h-11 w-full rounded-sm border border-ink/20 bg-ivory px-3.5 text-sm text-ink outline-none transition focus:border-black focus:ring-4 focus:ring-black/10',
        className
      )}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      className={cn(
        'min-h-24 w-full resize-y rounded-sm border border-ink/20 bg-ivory px-3.5 py-3 text-sm text-ink outline-none transition placeholder:text-ink/70 focus:border-black focus:ring-4 focus:ring-black/10',
        className
      )}
      {...props}
    />
  );
}
